module.exports = __webpack_public_path__ + "img/alert-circle.89397f5f.svg";